/*
* 数字入力ボックス
*/
import Simulation from '../simulation/index';
export default class StepNumberes {
  constructor() {
    this.$numberes = document.querySelectorAll('[data-target="numberBox"]');
    this.$increments = document.querySelectorAll('[data-target="numberBoxStepUp"]');
    this.$decrements = document.querySelectorAll('[data-target="numberBoxStepDown"]');
    this.$displayTotalAmount = document.querySelectorAll('[data-target="displayTotalAmount"]');
    this.$displayValue = document.querySelector('[data-target="displayValue"]');
    this.$entryButton = document.querySelector('[data-entry="entryButton"]');
    this.$error = document.querySelector('[data-target="error"]');
    this.$simulation = new Simulation();
  }

  attachEvent() {
    Array.prototype.forEach.call( this.$numberes, ($numberBox, index) => {
      const step = $numberBox.getAttribute('step');
      const min = $numberBox.getAttribute('min');
      const initialValue = $numberBox.value;
      $numberBox.setAttribute('data-initial-value', initialValue);
      $numberBox.setAttribute('data-is-initial', 'true');

      window.addEventListener('pageshow', () => {
        this.validation($numberBox);
      });

      this.$increments[index].addEventListener('click', () => {
        $numberBox.setAttribute('data-is-initial', 'false');
        $numberBox.value = parseInt($numberBox.value) + parseInt(step);
        this.displayValue($numberBox);
        this.validation($numberBox);

        this.$simulation.calculateSimulation();
      });

      this.$decrements[index].addEventListener('click', () => {
        $numberBox.setAttribute('data-is-initial', 'false');
        $numberBox.value = parseInt($numberBox.value) - parseInt(step);
        // 最小値以下の場合
        $numberBox.value = min > $numberBox.value ? min : $numberBox.value;
        this.displayValue($numberBox);
        this.validation($numberBox);

        this.$simulation.calculateSimulation();
      });

      $numberBox.addEventListener('input', () => {
        $numberBox.setAttribute('data-is-initial', 'false');
        this.displayValue($numberBox);
        this.validation($numberBox);

        this.$simulation.calculateSimulation();
      });

      // フォーカス時：初期値の場合は入力欄をクリア
      $numberBox.addEventListener('focus', () => {
        const isInitial = $numberBox.getAttribute('data-is-initial') === 'true';
        const initialValue = $numberBox.getAttribute('data-initial-value');
        if (isInitial && $numberBox.value === initialValue) {
          $numberBox.value = '';
        }
      });

      // フォーカス離脱時：空欄の場合は初期値に戻す
      $numberBox.addEventListener('blur', () => {
        if ($numberBox.value === '') {
          const initialValue = $numberBox.getAttribute('data-initial-value');
          $numberBox.value = initialValue;
          $numberBox.setAttribute('data-is-initial', 'true');
          this.displayValue($numberBox);
          this.validation($numberBox);
          this.$simulation.calculateSimulation();
        }
      });
    });
  }

  displayValue(target) {
    const basis = this.$displayTotalAmount[0].getAttribute('data-basis');
    const total = basis * target.value;
    const format = new Intl.NumberFormat('ja-JP', { style: 'decimal' }).format(total);

    if (this.$displayValue) {
      this.$displayValue.textContent = target.value;
    }

    Array.prototype.forEach.call( this.$displayTotalAmount, $item => {
      $item.textContent = `¥${format}`;
    });
  }

  validation(target) {
    if (this.$entryButton) {
      const isInitial = target.getAttribute('data-is-initial') === 'true';
      if (target.validity.valid) {
        if (this.$entryButton.classList.contains('is-active') && !isInitial) {
          this.$entryButton.disabled = false;
          this.$error.classList.add('is-hide');
        } else {
          this.$entryButton.disabled = true;
          this.$error.classList.add('is-hide');
        }
      } else {
        this.$entryButton.disabled = true;
        if (!isInitial) {
          this.$error.classList.remove('is-hide');
        } else {
          this.$error.classList.add('is-hide');
        }
      }
    }
  }
}
